<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-08-08 19:54:15
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>回访列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">回访列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="标题">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入标题"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="未完成" value="0"></el-option>
                    <el-option label="回访中" value="1"></el-option>
                    <el-option label="已完成" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="customId" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="customName" label="客户" align="center">
          </el-table-column>
          <el-table-column label="任务名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.jobTitle }}</span>
            </template>
          </el-table-column>
          <el-table-column label="任务完成时间" align="center" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.jobCashAt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="负责人" align="center">
          </el-table-column>
          <el-table-column label="回访超期" align="center" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.wantCallAt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">未完成</span>
              <span class="blueColor" v-if="scope.row.status == 1">回访中</span>
              <span class="greenColor" v-if="scope.row.status == 2"
                >已完成</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn"
                  @click="stop1(scope.row)"
                  v-if="scope.row.userId == '' || scope.row.userId == null"
                >
                  分配
                </div>
                <div
                  class="operateBtn"
                  @click="stop(scope.row)"
                  v-if="scope.row.userId != '' && scope.row.userId != null"
                >
                  取回
                </div>
                <div class="operateBtn" @click="goDetail(scope.row)">查看</div>
                <div
                  class="operateBtn"
                  @click="set(scope.row)"
                  v-if="scope.row.status != 2"
                >
                  记录
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="回访记录设置"
      :visible.sync="dialogFormVisible"
      width="600px"
    >
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="反馈内容" prop="content">
          <el-input
            v-model="ruleForm1.content"
            type="textarea"
            placeholder="请输入"
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-radio-group v-model="ruleForm1.select">
            <el-radio label="1">需再次回访</el-radio>
            <el-radio label="2">完结回访</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="分配设置"
      :visible.sync="dialogFormVisible1"
      width="800px"
    >
      <el-form ref="ruleForm" :model="ruleForm2">
        <el-row :gutter="4">
          <el-col :span="6">
            <el-form-item>
              <el-input
                v-model="ruleForm2.name"
                placeholder="请输入名称/手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="部门">
              <el-cascader
                :value="ruleForm2.status"
                :props="cateProps"
                :show-all-levels="false"
                :options="tableData2"
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-button type="primary" @click="getUserList()" class="btn"
                >查询</el-button
              >
              <el-button @click="resetForm1()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="singleTable"
        :data="tableData1"
        style="width: 100%"
        highlight-current-row
        @current-change="selectItem"
        max-height="250"
      >
        <el-table-column align="center" width="50">
          <template slot-scope="scope">
            <div class="select" v-if="scope.row.id == selectUser.id"></div>
          </template>
        </el-table-column>
        <el-table-column label="部门">
          <template slot-scope="scope">{{ scope.row.divisionName }}</template>
        </el-table-column>
        <el-table-column prop="name" label="姓名"> </el-table-column>
      </el-table>
      <div style="margin-top: 30px; text-align: right">
        <el-button type="primary" @click="allocation()" class="btn"
          >分配</el-button
        >
        <el-button @click="resetForm2()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        status: "",
      },
      ruleForm2: {
        name: "",
        status: "",
      },
      ruleForm1: {
        content: "",
        select: "",
      },
      tableData: [],
      tableData1: [],
      tableData2: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      rules: {
        select: [{ required: true, message: "请选择", trigger: "change" }],
      },
      setId: "",
      selectUser: "",
      allocationId: "",
      cateProps: {
        label: "name",
        value: "id",
        checkStrictly: true,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleChange(val) {
      this.ruleForm2.status = val[val.length - 1];
    },
    selectItem(val) {
      this.selectUser = val;
    },
    stop(val) {
      this.$confirm("是否取回", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/followup/takeback/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "取回成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    stop1(val) {
      this.$confirm("是否分配", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.getUserList();
          this.getdepartment();
          this.dialogFormVisible1 = true;
          this.allocationId = val.id;
        })
        .catch(() => {});
    },
    allocation() {
      if (!this.selectUser.id) {
        this.$message({
          message: "请选择客服",
          type: "warning",
        });
        return;
      }
      let param = {
        id: this.allocationId,
        userId: this.selectUser.id,
      };
      this.$axios
        .post(`/admapi/followup/allocation`, param)
        .then(({ data }) => {
          this.$message({
            message: "分配成功",
            type: "success",
          });
          this.dialogFormVisible1 = false;
          this.getList();
          this.selectUser = "";
          this.allocationId = "";
        })
        .catch()
        .finally();
    },
    getUserList() {
      let param = {
        page: 1,
        pageSize: 1000,
        pageNo: 1,
        queryParams: [
          { name: "name", type: "input", value: this.ruleForm2.name },
          { name: "phone", type: "input", value: this.ruleForm2.name },
        ],
      };
      if (this.ruleForm2.status != "") {
        param.queryParams.push({
          name: "division_id",
          type: "select",
          values: [
            {
              itemKey: this.ruleForm2.status,
            },
          ],
        });
      }
      this.$axios
        .post(`admapi/sys/users/list`, param)
        .then(({ data }) => {
          this.tableData1 = data.items;
        })
        .catch()
        .finally();
    },
    goDetail(val) {
      this.$router.push({
        path: "/followUpDetail",
        query: {
          id: val.id,
        },
      });
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.dialogFormVisible = false;
      this.getList();
    },
    resetForm1() {
      this.ruleForm2.name = "";
      this.ruleForm2.status = "";
      this.getUserList();
    },
    resetForm2() {
      this.selectUser = "";
      this.allocationId = "";
      this.dialogFormVisible1 = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm.name,
        });
      } else if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "sale_status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      this.$axios
        .post(`/admapi/followup/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    set(val) {
      this.dialogFormVisible = true;
      this.setId = val.id;
    },
    submitForm(formName) {
      let param = {
        id: this.setId,
        status: this.ruleForm1.select,
        memo: this.ruleForm1.content,
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post(`/admapi/followup/record`, param)
            .then(({ data }) => {
              this.$message({
                message: "记录成功",
                type: "success",
              });
            })
            .catch()
            .finally(() => {
              this.dialogFormVisible = false;
            });
        }
      });
    },
    getdepartment() {
      let param = {
        page: 1,
        pageSize: 1000,
        queryParams: [
          { name: "name", type: "input", value: this.ruleForm.name },
        ],
      };
      this.$axios
        .post(`/admapi/division/treelist`, param)
        .then(({ data }) => {
          this.tableData2 = data;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.select {
  width: 10px;
  height: 10px;
  background: #165dff;
  border-radius: 10px;
}
</style>
